import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import storeBambora from '@/store/storeBambora'
import storeCommande from '@/store/storeCommande'
import storeDemande from '@/store/storeDemande'
import storeMessage from '@/store/storeMessage'
import storePagination from '@/store/storePagination'
import storeUsager from '@/store/storeUsager'

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState()],
  modules: {
    storeBambora,
    storeCommande,
    storeDemande,
    storeMessage,
    storePagination,
    storeUsager
  }
})
